import { Collapse, CollapseProps, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { useStores } from "stores";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { routes } from "constants/routes";
import { AddCompanyButton } from "./AddCompany";
import { isUserActive } from "interfaces";

export const UserCompanyList = observer(() => {
  const { userCompanyList, userCard, user } = useStores();
  const navigate = useNavigate();

  const { isUserAdmin } = user.roles;

  const showAddUserButton = isUserAdmin && isUserActive(userCard.card.status);

  const collapseItem: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <Flex align="center">
          <Typography.Text strong className="whitebox-title">
            Организации
          </Typography.Text>
          {showAddUserButton && <AddCompanyButton />}
        </Flex>
      ),
      children: (
        <Flex vertical gap="large">
          <CommonTable
            store={userCompanyList}
            columns={getColumns(userCompanyList, user, userCard.card)}
            updateWithInterval
            onRow={(record) => ({
              onClick: () => {
                navigate(`/${routes.companies}/${record.id}`);
              },
              className: "cursor-pointer",
            })}
          />
        </Flex>
      ),
    },
  ];

  return <Collapse items={collapseItem} bordered={false} expandIconPosition="end" />;
});
